// extracted by mini-css-extract-plugin
module.exports = {"tags":"ProductTagList_tags__l2Jua"};